function currentPageUrl(explicitPageUrl) {
  if (explicitPageUrl) return explicitPageUrl;
  if (typeof window !== 'undefined' && window.location?.href) return window.location.href;
  return 'https://pfandpirat.invalid/';
}

export function normalizeAvatarUrl(value, explicitPageUrl) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const pageUrl = new URL(currentPageUrl(explicitPageUrl));
  let avatarUrl;

  try {
    avatarUrl = new URL(raw, pageUrl);
  } catch {
    return '';
  }

  if (!['http:', 'https:'].includes(avatarUrl.protocol)) return '';

  if (pageUrl.protocol === 'https:' && avatarUrl.protocol === 'http:') {
    if (avatarUrl.hostname !== pageUrl.hostname) return '';
    avatarUrl.protocol = 'https:';
  }

  return avatarUrl.href;
}

export function normalizePlayerAvatarPayload(payload = {}) {
  const selectedAvatar = payload?.selectedAvatar || payload?.selected_avatar || null;

  return {
    success: Boolean(payload?.success),
    message: payload?.message || '',
    selectedAvatarId: Number(payload?.selectedAvatarId ?? payload?.selected_avatar_id ?? 0),
    selectedAvatar,
    avatars: Array.isArray(payload?.avatars) ? payload.avatars : [],
    avatarUrl: String(payload?.avatarUrl ?? payload?.avatar_url ?? ''),
    avatarUrl2x: String(payload?.avatarUrl2x ?? payload?.avatar_url_2x ?? ''),
    wordpressAvatarUrl: String(payload?.wordpressAvatarUrl ?? payload?.wordpress_avatar_url ?? ''),
    fallbackAvatarUrl: String(payload?.fallbackAvatarUrl ?? payload?.fallback_avatar_url ?? ''),
  };
}

export function getPlayerAvatarSources(payload = {}, clientFallbackUrl = '', explicitPageUrl) {
  const normalized = normalizePlayerAvatarPayload(payload);
  const candidates = [
    normalized.selectedAvatar?.image_url,
    normalized.selectedAvatar?.thumb_url,
    normalized.avatarUrl,
    normalized.wordpressAvatarUrl,
    normalized.fallbackAvatarUrl,
    clientFallbackUrl,
  ];
  const seen = new Set();

  return candidates.reduce((sources, candidate) => {
    const url = normalizeAvatarUrl(candidate, explicitPageUrl);
    if (!url || seen.has(url)) return sources;
    seen.add(url);
    sources.push(url);
    return sources;
  }, []);
}
